import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { APPCONFIG } from '../../../config';
import { HttpService } from '../../../services/http.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {MatDialog,MatDialogRef} from '@angular/material/dialog';
import { sessionConfirmDialogComponent } from '@fuse/components/confirm-dialog-session/confirm-dialog-session.component';
@Component({
    selector: 'login',
    templateUrl: './login.component.html?v=${APPCONFIG.cacheVersion}',
    styleUrls: ['./login.component.scss?v=${APPCONFIG.cacheVersion}'],
    animations: fuseAnimations,
    providers: [HttpService]
})
export class LoginComponent implements OnInit, OnDestroy {
    readonly main_app_logo = APPCONFIG.main_app_logo;
    uploadedImage;
    confirmDialogRefSession: MatDialogRef<sessionConfirmDialogComponent>;
    jobPkId:any;
    result;
    title;
    imageSrc: String;
    bytesList;
    dataImg;
    loginForm: FormGroup;
    loginFormErrors: any;
    vehicleIdParam;
    jobData;
    jobApiData = {};
    profileForm: any;
    jobInputs: boolean = true;
    imageSrcData: any;
    job;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public route: ActivatedRoute,
        public _matDialogRef: MatDialogRef<any>,
        public dialog: MatDialog,
        private http1: HttpService,
        private spinner: NgxSpinnerService,
        private _router: Router,
        private ng2ImgMax: Ng2ImgMaxService,
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder, private http: HttpClient
    ) {
        console.log(this.jobApiData);
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                }
            }
        };

        // Set the defaults
        this.loginFormErrors = {
            email: {},
            password: {}
        };

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */

    onForm() {
        this.profileForm = new FormGroup({
            jobId: new FormControl(''
            )
        })
    }
    ngOnInit(): void {
        this.onForm();
        this.vehicleIdParam = this.route.snapshot.paramMap.get('jobId');
        console.log(this.vehicleIdParam);
        if (this.vehicleIdParam) {
            this.spinner.show();
            this.getCombineJobData();

            this.jobData = this.vehicleIdParam;
            this.jobInputs = false;
            this.imageSrcData = false;
        }
        else {
            this.imageSrcData = true;
        }

        this.loginForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required]
        });

        this.loginForm.valueChanges
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.onLoginFormValuesChanged();
            });
    }
    getJobData() {

        return this.http.get(APPCONFIG.appUrl + 'epw/getJob?jobId=' + this.vehicleIdParam);
    }


    getCombineJobData() {
        ;
        this.getJobData().subscribe(result => {
            this.spinner.hide();

            this.job = result;
            this.jobApiData = this.job.data;
           this.jobPkId = this.jobApiData
            console.log(this.jobApiData);
            this._router.navigate(['/pages/epw/detail/' + this.vehicleIdParam]);
        },
            err => {
                let title = "Failed to retrive data, Please Click job again";
                this.http1.errorHandler(err, title);
                this.spinner.hide();
            });
    }

    postData() {
        this.spinner.show();

        this.dataImg = this.imageSrc.replace(/^data:image\/\w+;base64,/, "");
        const user = {epwImage: this.dataImg, jobPkId: this.jobPkId.jobPkId};
        console.log(user);
        
        let body = JSON.stringify(user);
       
        console.log(body);
        
        
        this.http.post(APPCONFIG.appUrl + 'epw/create', user)
          .subscribe(data => {
              
            if(data){
            }
                  this.result = data;
                  if(this.result.httpStatusCode==201 || this.result.statusCode == 1){
                    this.title = "Successfully Submitted";
                    this.confirmDialogRefSession = this.dialog.open(sessionConfirmDialogComponent);
                    this.confirmDialogRefSession.componentInstance.confirmMessage = this.title;
                    this.spinner.hide();
                    
                } 
                if(this.result.httpStatusCode==200 || this.result.statusCode == 1){
                  this.title = "Successfully Submitted";
                  this.confirmDialogRefSession = this.dialog.open(sessionConfirmDialogComponent);
                  this.confirmDialogRefSession.componentInstance.confirmMessage = this.title;
                  this.spinner.hide();
               } 
           
          },
          err => {
            let title = "Failed to submit data";
            this.http1.errorHandler(err, title);
            this.spinner.hide();
        });
      }
    onSubmit() {
        console.log(this.bytesList);
        
                   
        if(this.profileForm.value.jobId){

        }
        else{this.postData();}
        
        console.log(this.profileForm.value.jobId);
        if (this.profileForm.value.jobId) {
            this._router.navigate(['/pages/epw/detail/' + this.profileForm.value.jobId]);
        }
        else {
            //this._router.navigate(['/pages/epw/detail']);
        }
    }
    readURL(event: Event): void {
        this.spinner.show();
        
        var bytes = [];
        if ((<HTMLInputElement>event.target).files && (<HTMLInputElement>event.target).files[0]) {
            const file = (<HTMLInputElement>event.target).files[0];
            this.ng2ImgMax.resizeImage(file, 300, 200).subscribe(
                result => {
                    this.uploadedImage = result;
                    
                    
                    
                    const reader = new FileReader();
                    reader.onload = e => {
                        this.imageSrc = reader.result;
                        this.imageSrcData = true;
                        
                        
                        console.log(this.imageSrc);
                        for (var i = 0; i < this.imageSrc.length; ++i) {
                            bytes.push(this.imageSrc.charCodeAt(i));
                            bytes.push(0);
                        }
                        this.bytesList = bytes;
                    }
                    reader.readAsDataURL(this.uploadedImage)
                    this.spinner.hide();
                },
                error => {
                    this.spinner.hide();
                    console.log(' Oh no!', error);
                })
            /* const reader = new FileReader();
            reader.onload = e => {this.imageSrc = reader.result;
                console.log(this.imageSrc);
                for (var i = 0; i < this.imageSrc.length; ++i)
                {
                    bytes.push(this.imageSrc.charCodeAt(i));
                    bytes.push(0);
                }
                this.bytesList = bytes;
                console.log("bytes",bytes);}
                reader.readAsDataURL(file) */
        }

    }




    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On form values changed
     */
    onLoginFormValuesChanged(): void {
        for (const field in this.loginFormErrors) {
            if (!this.loginFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.loginFormErrors[field] = {};

            // Get the control
            const control = this.loginForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.loginFormErrors[field] = control.errors;
            }
        }
    }
}
